const SAFE_PROTOCOLS = new Set(['http:', 'https:']);
// Browsers drop tab, CR and LF before parsing a URL, so `/<TAB>/host` becomes `//host`.
// eslint-disable-next-line no-control-regex -- matching control characters is the point
const CONTROL_CHARACTERS = /[\u0000-\u001f\u007f]/;
function resolvesToCurrentOrigin(path) {
    try {
        return new URL(path, window.location.href).origin === window.location.origin;
    }
    catch (_a) {
        return false;
    }
}
/**
 * Whether a server-supplied link is safe to hand to `window.open`.
 *
 * Accepts a path that resolves to this page's own origin (`/inspections/123`) or an
 * absolute http(s) URL. A path is judged by where the browser would resolve it, not
 * by its first characters: `//host`, `/\host` and `/<TAB>/host` all start with `/`
 * and all leave the origin. `javascript:`, `data:`, `file:` and `blob:` are rejected.
 */
export function isSafeLink(url) {
    if (CONTROL_CHARACTERS.test(url))
        return false;
    if (url.startsWith('/'))
        return resolvesToCurrentOrigin(url);
    try {
        return SAFE_PROTOCOLS.has(new URL(url).protocol);
    }
    catch (_a) {
        return false;
    }
}
/**
 * Opens a link in a new browsing context, the way DeepLinkRenderer does. The
 * iOS webview loads it in-view with the native back chevron, and intercepts
 * `maps.apple.com` natively. Returns whether the link was opened.
 */
export function openSafeUrl(url) {
    if (!isSafeLink(url))
        return false;
    window.open(url, '_blank', 'noopener,noreferrer');
    return true;
}
